import type { Clue, ConstructorGrid, Pairing } from '../types'

function formatClueLine(label: string, clue: Clue | undefined): string {
  const text = clue?.text.trim()
  return `${label}: ${text || '[no clue]'}`
}

function getUniqueDrafts(currentClue: Clue | undefined, draftClues: Clue[] | undefined): Clue[] {
  const currentText = currentClue?.text.trim().toLowerCase()
  const seen = new Set<string>()
  const drafts: Clue[] = []

  for (const draft of draftClues ?? []) {
    const text = draft.text.trim()
    if (!text) continue
    const key = text.toLowerCase()
    if (key === currentText || seen.has(key)) continue
    seen.add(key)
    drafts.push(draft)
  }

  return drafts
}

export function buildPlacedPairsPlainText(
  grid: ConstructorGrid | null,
  pairings: Pairing[],
  listNames: { A: string; B: string }
): string {
  const placements = grid?.placements ?? []
  const pairingsById = new Map(pairings.map(pairing => [pairing.id, pairing]))
  const lines: string[] = [
    'Crossword pairs and clues',
    `${listNames.A} / ${listNames.B}`,
    '',
  ]

  if (placements.length === 0) {
    lines.push('[no placed pairs]')
    return `${lines.join('\n')}\n`
  }

  for (const placement of placements) {
    const pairing = placement.pairingId ? pairingsById.get(placement.pairingId) : undefined
    const currentClue = pairing?.clue
    const draftClues = getUniqueDrafts(currentClue, pairing?.clueDrafts)

    lines.push(`${placement.wordAText.replace(/\s/g, '')} / ${placement.wordBText.replace(/\s/g, '')}`)
    lines.push(formatClueLine(currentClue?.status === 'final' ? 'Final clue' : 'Clue', currentClue))

    if (draftClues.length > 0) {
      lines.push('Drafts:')
      for (const draft of draftClues) {
        lines.push(`- ${draft.text.trim()}`)
      }
    }

    lines.push('')
  }

  return `${lines.join('\n').trimEnd()}\n`
}
